import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const ArrowSolidRight = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.46 18H10.46C10.146 17.9982 9.83587 17.93 9.55 17.8C8.91856 17.5217 8.50803 16.9 8.5 16.21V7.79002L8.5 7.79003C8.50803 7.10002 8.91856 6.47836 9.54999 6.20003V6.20003C10.2758 5.85719 11.1336 5.95811 11.76 6.46003L16.86 10.67C17.5945 11.2548 17.7159 12.3243 17.1312 13.0588C17.0513 13.1592 16.9603 13.2502 16.86 13.33L11.76 17.54C11.3924 17.8382 10.9333 18.0006 10.46 18L10.46 18Z",
            fill: "currentColor"
        })
    });
};
